import React, { createContext, useContext, useState } from 'react';

interface DialogContextType {
  showImpressum: boolean;
  showDatenschutz: boolean;
  toggleImpressum: () => void;
  toggleDatenschutz: () => void;
}

const DialogContext = createContext<DialogContextType | undefined>(undefined);

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);

  const toggleImpressum = () => {
    setShowImpressum(!showImpressum);
  };

  const toggleDatenschutz = () => {
    setShowDatenschutz(!showDatenschutz);
  };

  return (
    <DialogContext.Provider value={{ showImpressum, showDatenschutz, toggleImpressum, toggleDatenschutz }}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = (): DialogContextType => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error('useDialog must be used within a DialogProvider');
  }
  return context;
};
